module.exports = __webpack_public_path__ + "static/media/Troubadour.ccd246d0.jpg";